var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "infinity-scroll" },
    [
      _vm._t(
        "header",
        function () {
          return [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.hasTitle,
                    expression: "hasTitle",
                  },
                ],
                staticClass: "infinity-scroll--title",
              },
              [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]
            ),
          ]
        },
        { title: _vm.title, reloadData: _vm.reloadData }
      ),
      _vm._v(" "),
      _vm.hasItems
        ? [
            _c(
              "div",
              {
                staticClass: "infinity-scroll--list",
                class: _vm.classWrapperList,
              },
              [
                _vm._l(_vm.items, function (item, index) {
                  return [
                    _vm._t(
                      "list",
                      function () {
                        return [
                          _c(
                            "div",
                            {
                              key: `item-${index}`,
                              staticClass: "card",
                              class: _vm.classItem,
                            },
                            [
                              _c("div", { staticClass: "card-body" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(item) +
                                    "\n                        "
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                      { item: item, index: index, total: _vm.total }
                    ),
                  ]
                }),
              ],
              2
            ),
          ]
        : !_vm.loading
        ? [
            _vm._t("no-records", function () {
              return [
                _c("div", { staticClass: "card pt-4" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("p", { staticClass: "subtitle text-center" }, [
                      _vm._v(_vm._s(_vm.noRecords)),
                    ]),
                  ]),
                ]),
              ]
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.hasNextPage
        ? _vm._t(
            "load-more",
            function () {
              return [
                _c("div", { staticClass: "d-flex justify-content-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-rounded btn-sm btn-responsive",
                      class: _vm.loadMoreClass,
                      attrs: { type: "buttom", disabled: _vm.loading },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.loadMore.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm.loading
                        ? _c("i", { staticClass: "fas fa-spinner fa-pulse" })
                        : _vm._e(),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.loadMoreRecords) +
                          "\n            "
                      ),
                    ]
                  ),
                ]),
              ]
            },
            { loadMore: _vm.loadMore }
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }